import React, { useState } from 'react'
import { firestore } from '../Firebase';
import Axios from 'axios'
import { Link } from 'react-router-dom';
import AppBar from '../components/AppBar.js'

function ForgotPassword() {
    const [email, setEmail] = useState("");

    const sendEmail = async (e) => {
        e.preventDefault();
        var password = ""
        var username = ""
        const matches = await firestore.collection('accounts').where('email', '==', email).get()
        matches.forEach(doc => {
            password = doc.data().password
            username = doc.data().username
        })
        if (password !== "") {
            alert("We have sent you your password")
            var dest = "?dest=" + email
            var subject = "&subject=Password retrieval DecodeLabs"
            var message = "&message=Password: " + password + ". Username: " + username
            var path = "https://us-central1-dyslexia-d9e5d.cloudfunctions.net/sendMail"
            Axios.get(path + dest + subject + message)
        } else {
            alert("We were unable to find your accont. Please register.")
        }
    }

    return (
        <div>
            <AppBar />
            <div className='signupFormDiv' style={{ marginTop: 10 }}>
                <b class='titleText' style={{ marginTop: 30, marginBottom: 40, fontSize: 50, textAlign: "center" }}>Enter your email below</b>
                <form className="signupForm" onSubmit={sendEmail}>
                    <input value={email} onChange={(e) => setEmail(e.target.value)} className="signupFormTextField" placeholder="Email"></input>
                    <div className='submitArea'><button type='submit' className='signupFormSubmitButton'>Submit</button></div><br />
                    <div className='submitArea'><Link to='/' style={{ textDecoration: 'none' }} className='signupFormSubmitButton'>Back to Sign In</Link></div>
                </form>
            </div>
        </div>
    )
}

export default ForgotPassword
